export default __webpack_public_path__ + "static/media/banner.f5f77f75.png";